var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-tr",
    {
      staticClass: "custom-table__row",
      nativeOn: {
        click: function ($event) {
          return _vm.$emit("clickedRow", _vm.record)
        },
      },
    },
    [
      _c("mds-td", { staticClass: "custom-table__column" }, [
        _vm._v(_vm._s(_vm.record.name)),
      ]),
      _vm._v(" "),
      _c("mds-td", { staticClass: "custom-table__column" }, [
        _vm._v(_vm._s(_vm.record.id)),
      ]),
      _vm._v(" "),
      _c("mds-td", { staticClass: "custom-table__column" }, [
        _vm._v(_vm._s(_vm.record.source)),
      ]),
      _vm._v(" "),
      _c("mds-td", { staticClass: "custom-table__column" }, [
        _c("div", [_vm._v(_vm._s(_vm.record.lastUpdate.date))]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.record.lastUpdate.date !== "—",
                expression: "record.lastUpdate.date !== '—'",
              },
            ],
            staticClass: "custom-table__time",
          },
          [_vm._v("\n      " + _vm._s(_vm.lastUpdateDate) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "mds-td",
        { staticClass: "custom-table__column" },
        [
          _c(
            "CustomTableActions",
            _vm._g(
              {
                attrs: {
                  record: _vm.record,
                  rowId: _vm.record.id,
                  actions: _vm.actions,
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }